import { ROUTES } from "../constants";

const buildAdminTabPath = (tab) => `${ROUTES.ADMIN}?tab=${tab}`;
const adminUsersPath = buildAdminTabPath("users");
const adminSitesPath = buildAdminTabPath("sites");
const adminRolesPath = buildAdminTabPath("roles");

const extractDataPath = (data = {}) => {
	if (!data) return null;
	const candidate =
		data.cta_path ||
		data.ctaPath ||
		data.path ||
		data.href ||
		data.url;
	if (typeof candidate === "string" && candidate.trim()) {
		return candidate.trim();
	}
	return null;
};

const buildOrderHistoryPathWithOrder = (notification = {}) => {
	const data = notification.data || {};
	
	let orderNumber = null;

	if (!orderNumber && notification.title) {
		const titleMatch = notification.title.match(/Order\s+Placed:\s*(.+?)$/i);
		if (titleMatch && titleMatch[1]) {
			orderNumber = titleMatch[1].trim();
		}
	}
	
	if (orderNumber) {
		return `${ROUTES.ORDER_HISTORY}?open_number=${encodeURIComponent(orderNumber)}`;
	}
	
	return ROUTES.ORDER_HISTORY;
};

export const getNotificationNavigationTarget = (notification = {}) => {
	if (!notification) return null;

	const directPath = extractDataPath(notification.data);
	if (directPath) return directPath;

	const key = String(
		notification.event_key || notification.data?.event_key || ""
	).toUpperCase();
	if (!key) return null;

	if (key.includes("REQUEST")) return ROUTES.REQUESTS;
	if (key.includes("ORDER") || key.includes("CART")) return buildOrderHistoryPathWithOrder(notification);
	if (key.includes("DOCUMENT")) return ROUTES.DOCUMENT;
	if (key.includes("CUSTOMER_CARE") || key.includes("SUPPORT") || key.includes("CASE") )
		// || key.includes("CONTACT") // add if ccr page is available
		return ROUTES.SUPPORT;
	if (key.includes("MACHINE")) return ROUTES.MACHINES;
	if (key.includes("PASSWORD") || key.includes("ACCOUNT")) return ROUTES.PROFILE;
	if (key.includes("SITE")) return adminSitesPath;
	if (key.includes("ROLE")) return adminRolesPath;
	if (key.includes("USER")) return adminUsersPath;
	if (key.includes("ADMIN")) return ROUTES.ADMIN;

	return null;
};
